/**
 * Toserof Speed Optimizer
 * Her tema, her mağaza ile uyumlu evrensel optimizasyon scripti.
 * Shopify Plus gerekmez.
 *
 * @version 1.3.2
 */
window.__TOSEROF_OPTIMIZER_VERSION__ = "1.3.2";
(function () {
  "use strict";

  const CONFIG = window.__TOSEROF_CONFIG__ || {};
  const SHOP = CONFIG.shop || "";
  const API_URL = CONFIG.apiUrl || "";

  let _lcpElement = null;
  let _settings = null;
  let _firstCssSeen = false;
  let _earlyVideoHandled = false;
  let _earlyImgHandled = false;
  let _earlyBgHandled = false;
  let _interactionFired = false;
  const _pendingScripts = [];
  const _interactionCallbacks = [];

  const THIRD_PARTY_PATTERNS = [
    "googletagmanager.com", "google-analytics.com", "analytics.google.com",
    "googleadservices.com", "googleoptimize.com", "doubleclick.net",
    "facebook.net", "connect.facebook.net", "fbcdn.net",
    "analytics.tiktok.com", "ads.tiktok.com", "business.tiktok.com",
    "klaviyo.com", "static-tracking.klaviyo.com", "static.klaviyo.com",
    "monorail-edge.shopifysvc.com",
    "hotjar.com", "static.hotjar.com", "script.hotjar.com",
    "clarity.ms",
    "zdassets.com", "zopim.com", "zendesk.com",
    "intercom.io", "intercomcdn.com",
    "tawk.to", "crisp.chat", "tidio.com", "freshchat.com", "livechatinc.com",
    "ct.pinterest.com",
    "snap.licdn.com", "px.ads.linkedin.com",
    "bugsnag.com", "sentry.io", "sentry-cdn.com",
    "pixel.reddit.com", "redditstatic.com",
    "bat.bing.com",
    "mc.yandex.ru",
    "criteo.net", "criteo.com",
    "smartlook.com", "mouseflow.com", "fullstory.com",
    "hs-scripts.com", "hs-analytics.net", "hubspot.com",
    "vitals.app", "cdn-sf.vitals.app",
    "pay.google.com", "pay.sandbox.google.com",
    "translate.googleapis.com", "translate.google.com", "translate-pa.googleapis.com",
    "appsolve.io",
    "bugsnag.com", "d2wy8f7a9ursnm.cloudfront.net",
    "trekkie.storefront"
  ];

  const CRITICAL_CSS_PATTERNS = [
    "critical", "base.css", "global.css", "theme.css",
    "checkout", "cart"
  ];

  const CRITICAL_JS_PATTERNS = [
    "shopify.com/s/", "shopifycdn", "cdn.shopify",
    "checkout", "cart", "toserof", "jquery", "recaptcha"
  ];

  const THEME_DEFERRABLE_PATTERNS = [
    "aos.js", "aos.min.js",
    "gsap.min.js", "gsap.js", "scrolltrigger",
    "swiper.min.js", "swiper.js", "swiper-bundle",
    "splide.min.js", "splide.js",
    "lenis", "locomotive-scroll",
    "slick.min.js", "slick.js", "owl.carousel",
    "lottie", "lottie-player",
    "three.min.js", "three.js",
    "tippy", "@popperjs", "popper.min.js",
    "fancybox", "photoswipe",
    "mega-menu", "megamenu",
    "instafeed", "wow.min.js", "wow.js",
    "splitting", "splittext",
    "matter.js", "pixi.min.js"
  ];

  const THEME_NEVER_DEFER = [
    "lazyload", "lazysizes",
    "shopify-perf-kit",
    "predictive-search"
  ];

  const PRECONNECT_KEEP = [
    "cdn.shopify.com",
    "fonts.googleapis.com",
    "fonts.gstatic.com"
  ];

  const INTERACTION_EVENTS = [
    "pointerdown", "touchstart", "mousemove", "scroll",
    "keydown", "wheel", "click"
  ];

  function lc(s) { return String(s || "").toLowerCase(); }

  function matchesThirdParty(src) {
    if (!src) return false;
    const lower = lc(src);
    for (let i = 0; i < THIRD_PARTY_PATTERNS.length; i++) {
      if (lower.indexOf(THIRD_PARTY_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function isCriticalJs(src) {
    const lower = lc(src);
    for (let i = 0; i < CRITICAL_JS_PATTERNS.length; i++) {
      if (lower.indexOf(CRITICAL_JS_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function isCriticalCss(href) {
    const lower = lc(href);
    for (let i = 0; i < CRITICAL_CSS_PATTERNS.length; i++) {
      if (lower.indexOf(CRITICAL_CSS_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function matchesDeferableTheme(src) {
    if (!src) return false;
    const lower = lc(src);
    if (isCriticalJs(src)) return false;
    for (let i = 0; i < THEME_NEVER_DEFER.length; i++) {
      if (lower.indexOf(THEME_NEVER_DEFER[i]) !== -1) return false;
    }
    for (let i = 0; i < THEME_DEFERRABLE_PATTERNS.length; i++) {
      if (lower.indexOf(THEME_DEFERRABLE_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function shouldDelayScript(src) {
    if (matchesThirdParty(src) && !isCriticalJs(src)) return true;
    if (_settings && _settings.deferThemeScripts && matchesDeferableTheme(src)) return true;
    return false;
  }

  // ─── INTERACTION HUB ─────────────────────────────────────────────────────

  function onInteraction(cb) {
    if (_interactionFired) { try { cb(); } catch (e) {} return; }
    _interactionCallbacks.push(cb);
  }

  function fireInteraction() {
    if (_interactionFired) return;
    _interactionFired = true;
    for (let i = 0; i < INTERACTION_EVENTS.length; i++) {
      try { window.removeEventListener(INTERACTION_EVENTS[i], fireInteraction, { capture: true }); } catch (e) {}
    }
    while (_interactionCallbacks.length) {
      try { _interactionCallbacks.shift()(); } catch (e) {}
    }
  }

  for (let i = 0; i < INTERACTION_EVENTS.length; i++) {
    window.addEventListener(INTERACTION_EVENTS[i], fireInteraction, { passive: true, capture: true, once: true });
  }
  setTimeout(fireInteraction, 7000);

  // ─── PHASE 0: SYNC PRECONNECTS (3 critical only) ─────────────────────────

  function injectPreconnect(href, crossorigin) {
    if (!document.head) return;
    if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = href;
    if (crossorigin) link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  }

  injectPreconnect("https://cdn.shopify.com", true);
  injectPreconnect("https://fonts.googleapis.com");
  injectPreconnect("https://fonts.gstatic.com", true);

  // ─── PHASE 0: ANIMATION KILL ─────────────────────────────────────────────

  (function injectAnimationKillStyles() {
    if (!document.head) return;
    if (document.getElementById("toserof-anim-kill")) return;
    const style = document.createElement("style");
    style.id = "toserof-anim-kill";
    style.textContent =
      '[data-aos]:not(.aos-animate),' +
      '[data-reveal]:not(.revealed),' +
      '[data-motion]:not(.motion-active),' +
      '[data-scroll]:not(.is-inview),' +
      '[data-scroll-section],' +
      '[data-splitting],' +
      '.reveal:not(.revealed),' +
      '.fade-in:not(.active),' +
      '.scroll-trigger,' +
      '.gsap-reveal,' +
      '.split-text,.split-line,.split-word,.split-char,' +
      '.has-animation,' +
      '.has-scroll-init,' +
      '.has-motion,' +
      '.js-reveal,.is-revealed,' +
      '.wow,' +
      '.animate--fade-in,' +
      '.animate--slide-in,' +
      '.animate--ambient,' +
      '[data-splide]:not(.is-initialized),' +
      '[data-swiper]:not(.swiper-initialized),' +
      '.swiper-container:not(.swiper-initialized),' +
      '.splide:not(.is-initialized){' +
      'opacity:1!important;transform:none!important;' +
      'animation:none!important;transition:none!important;' +
      '}';
    document.head.appendChild(style);
  })();

  function injectUniversalTransitionKill() {
    if (!document.head) return;
    if (document.getElementById("toserof-universal-kill")) return;
    const style = document.createElement("style");
    style.id = "toserof-universal-kill";
    style.textContent =
      '*:not(html):not(body){' +
      'transition-duration:0s!important;' +
      'animation-duration:0.01ms!important;' +
      'animation-iteration-count:1!important;' +
      '}';
    document.head.appendChild(style);
    const removeKill = function () {
      const el = document.getElementById("toserof-universal-kill");
      if (el) el.remove();
    };
    window.addEventListener("load", function () {
      setTimeout(removeKill, 800);
    }, { once: true });
    setTimeout(removeKill, 5000);
  }

  // ─── PHASE 0: SYNC SCAN (existing CSS/preconnect in head before us) ──────

  (function syncCssAndPreconnectScan() {
    if (!document.head) return;
    const links = document.head.querySelectorAll("link");
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const rel = lc(link.getAttribute("rel"));
      const href = link.getAttribute("href") || "";

      if (rel === "preconnect") {
        let keep = false;
        for (let k = 0; k < PRECONNECT_KEEP.length; k++) {
          if (href.indexOf(PRECONNECT_KEEP[k]) !== -1) { keep = true; break; }
        }
        if (!keep) {
          link.setAttribute("rel", "dns-prefetch");
          link.removeAttribute("crossorigin");
        }
        continue;
      }

      if (rel === "stylesheet") {
        if (href.indexOf("fonts.googleapis.com") !== -1) {
          makeFontLinkNonBlocking(link);
          _firstCssSeen = true;
          continue;
        }
        if (isCriticalCss(href)) { _firstCssSeen = true; continue; }
        if (link.hasAttribute("data-shopify")) continue;
        if (!_firstCssSeen) { _firstCssSeen = true; continue; }
        deferStylesheetLink(link);
      }
    }
  })();

  // ─── PHASE 0: 3RD PARTY INTERCEPT ────────────────────────────────────────

  const origCreateElement = Document.prototype.createElement;
  const scriptSrcDesc = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src");
  const origSetAttribute = Element.prototype.setAttribute;

  function scheduleScriptForInteraction(el, src) {
    _pendingScripts.push({ el: el, src: src });
    onInteraction(function () {
      try { scriptSrcDesc.set.call(el, src); } catch (e) {
        try { origSetAttribute.call(el, "src", src); } catch (e2) {}
      }
    });
  }

  function installScriptSrcTrap(el) {
    if (el.__toserofTrapped) return;
    el.__toserofTrapped = true;
    let _pending = "";
    let _scheduled = false;
    Object.defineProperty(el, "src", {
      get: function () {
        return _pending || scriptSrcDesc.get.call(el);
      },
      set: function (v) {
        if (!_interactionFired && matchesThirdParty(v) && !isCriticalJs(v)) {
          _pending = v;
          if (!_scheduled) {
            _scheduled = true;
            scheduleScriptForInteraction(el, v);
          }
          return;
        }
        scriptSrcDesc.set.call(el, v);
      },
      configurable: true
    });
  }

  Document.prototype.createElement = function (tagName) {
    const el = origCreateElement.apply(this, arguments);
    if (typeof tagName === "string" && tagName.toLowerCase() === "script") {
      installScriptSrcTrap(el);
    }
    return el;
  };

  Element.prototype.setAttribute = function (name, value) {
    if (this && this.tagName === "SCRIPT" && name && lc(name) === "src") {
      if (!_interactionFired && matchesThirdParty(value) && !isCriticalJs(value)) {
        const el = this;
        scheduleScriptForInteraction(el, value);
        return;
      }
    }
    return origSetAttribute.apply(this, arguments);
  };

  // ─── PHASE 0: EARLY MUTATION OBSERVER ────────────────────────────────────

  function injectVideoPreloadLink(src) {
    if (!src || !document.head) return;
    if (document.querySelector('link[rel="preload"][as="video"][href="' + src + '"]')) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "video";
    link.href = src;
    link.setAttribute("fetchpriority", "high");
    document.head.appendChild(link);
  }

  function injectImagePreloadLink(src) {
    if (!src || !document.head) return;
    let href = src;
    if (src.indexOf("cdn.shopify.com") !== -1) {
      try {
        const url = new URL(src, location.href);
        url.searchParams.set("format", "webp");
        href = url.toString();
      } catch (e) {}
    }
    if (document.querySelector('link[rel="preload"][as="image"][href="' + href + '"]')) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = href;
    link.setAttribute("fetchpriority", "high");
    document.head.appendChild(link);
  }

  function earlyPreloadVideo(video) {
    try {
      video.setAttribute("preload", "auto");
      video.setAttribute("fetchpriority", "high");
    } catch (e) {}
    let src = video.getAttribute("src") || video.getAttribute("data-src") || "";
    if (!src && video.querySelector) {
      const s = video.querySelector("source[src], source[data-src]");
      if (s) src = s.getAttribute("src") || s.getAttribute("data-src") || "";
    }
    if (src) injectVideoPreloadLink(src);
  }

  function earlyPreloadImg(img) {
    const src = img.getAttribute("src") || img.getAttribute("data-src") || "";
    try {
      img.setAttribute("fetchpriority", "high");
      img.setAttribute("loading", "eager");
      img.setAttribute("decoding", "sync");
    } catch (e) {}
    if (src) injectImagePreloadLink(src);
  }

  function deferStylesheetLink(link) {
    if (link.__toserofDeferred) return;
    if (link.sheet) return;
    link.__toserofDeferred = true;
    const origMedia = link.getAttribute("media") || "all";
    link.setAttribute("data-toserof-media", origMedia);
    link.setAttribute("media", "print");
    const restore = function () { link.setAttribute("media", origMedia); };
    link.addEventListener("load", restore, { once: true });
  }

  function makeFontLinkNonBlocking(link) {
    const href = link.getAttribute("href") || "";
    if (href.indexOf("display=swap") === -1) {
      link.setAttribute("href", href + (href.indexOf("?") > -1 ? "&" : "?") + "display=swap");
    }
    if (link.__toserofFontDeferred) return;
    link.__toserofFontDeferred = true;
    const origMedia = link.getAttribute("media") || "all";
    link.setAttribute("media", "print");
    const restore = function () { link.setAttribute("media", origMedia); };
    link.addEventListener("load", restore, { once: true });
    if (link.sheet) restore();
  }

  function extractBgUrl(styleStr) {
    if (!styleStr) return "";
    const m = styleStr.match(/background(?:-image)?\s*:[^;]*url\((['"]?)([^'")]+)\1\)/i);
    return m ? m[2] : "";
  }

  function looksLikeHeroClass(node) {
    const cls = lc(node.className || "");
    if (!cls) return false;
    return cls.indexOf("hero") !== -1 ||
           cls.indexOf("banner") !== -1 ||
           cls.indexOf("slideshow") !== -1 ||
           cls.indexOf("image-banner") !== -1 ||
           cls.indexOf("background--overlay") !== -1;
  }

  function earlyPreloadBg(url) {
    if (!url || !document.head) return;
    if (url.indexOf("//") === 0) url = "https:" + url;
    injectImagePreloadLink(url);
  }

  function handleEarlyNode(node) {
    if (!node || node.nodeType !== 1) return;
    const tag = node.tagName;

    if (tag === "VIDEO" && !_earlyVideoHandled) {
      _earlyVideoHandled = true;
      earlyPreloadVideo(node);
      return;
    }

    if (tag === "IMG" && !_earlyImgHandled) {
      const w = parseInt(node.getAttribute("width") || "0", 10);
      const h = parseInt(node.getAttribute("height") || "0", 10);
      const hasPriority = lc(node.getAttribute("fetchpriority") || "") === "high";
      if (w >= 600 || h >= 400 || hasPriority) {
        _earlyImgHandled = true;
        earlyPreloadImg(node);
      }
      return;
    }

    if (!_earlyBgHandled && (tag === "DIV" || tag === "SECTION")) {
      const style = node.getAttribute("style");
      if (style && style.indexOf("background") !== -1) {
        const url = extractBgUrl(style);
        if (url && (looksLikeHeroClass(node) || _earlyBgHandled === false && (!_earlyImgHandled && !_earlyVideoHandled))) {
          if (looksLikeHeroClass(node)) {
            _earlyBgHandled = true;
            earlyPreloadBg(url);
          }
        }
      }
    }

    if (tag === "LINK") {
      const rel = lc(node.getAttribute("rel"));
      const href = node.getAttribute("href") || "";
      if (rel === "stylesheet") {
        if (href.indexOf("fonts.googleapis.com") !== -1) {
          makeFontLinkNonBlocking(node);
          _firstCssSeen = true;
          return;
        }
        if (isCriticalCss(href)) {
          _firstCssSeen = true;
          return;
        }
        if (!_firstCssSeen) {
          _firstCssSeen = true;
          return;
        }
        deferStylesheetLink(node);
      }
    }
  }

  let _earlyObserver = null;
  if ("MutationObserver" in window) {
    _earlyObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const added = mutations[i].addedNodes;
        for (let j = 0; j < added.length; j++) {
          handleEarlyNode(added[j]);
        }
      }
    });
    if (document.documentElement) {
      _earlyObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // ─── SETTINGS ─────────────────────────────────────────────────────────────

  function mergeWithDefaults(data) {
    const defaults = getDefaultSettings();
    if (!data || typeof data !== "object") return defaults;
    const merged = {};
    for (const k in defaults) merged[k] = defaults[k];
    for (const k in data) {
      if (data[k] !== undefined && data[k] !== null) merged[k] = data[k];
    }
    return merged;
  }

  async function getSettings() {
    const cacheKey = "toserof_settings_v2";
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) return mergeWithDefaults(JSON.parse(cached));
    } catch (e) {}

    if (!API_URL || !SHOP) return getDefaultSettings();

    try {
      const res = await fetch(API_URL + "/api/public/settings?shop=" + encodeURIComponent(SHOP));
      if (!res.ok) return getDefaultSettings();
      const data = await res.json();
      try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (e) {}
      return mergeWithDefaults(data);
    } catch (e) {
      return getDefaultSettings();
    }
  }

  function getDefaultSettings() {
    return {
      enabled: true,
      lazyLoadImages: true,
      webpConversion: true,
      responsiveImages: true,
      preventLayoutShift: true,
      fontDisplaySwap: true,
      preconnectFonts: true,
      dnsPrefetch: true,
      preloadHeroImage: true,
      deferThirdPartyScripts: true,
      delayThirdPartyUntilInteraction: true,
      youtubeFacade: true,
      videoLazyLoad: true,
      removeLcpAnimations: true,
      preloadCriticalFonts: true,
      deferNonCriticalCss: true,
      deferNonCriticalJs: true,
      preconnectExternalDomains: [],
      fixImageDimensions: true,
      cleanupPreconnects: true,
      aggressiveAnimationKill: false,
      deferThemeScripts: false
    };
  }

  // ─── CHUNKED RUNNER ──────────────────────────────────────────────────────

  const idle = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 1500 }); }
    : function (fn) { setTimeout(fn, 0); };

  function runChunked(tasks) {
    function next() {
      if (!tasks.length) return;
      idle(function () {
        const t = tasks.shift();
        try { t(); } catch (e) {}
        next();
      });
    }
    next();
  }

  // ─── 1. LCP OPTIMIZATION (preserved name) ────────────────────────────────

  function findLcpCandidate(candidates) {
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    let best = null, bestArea = 0;
    for (let i = 0; i < candidates.length; i++) {
      const el = candidates[i];
      const rect = el.getBoundingClientRect();
      if (rect.top >= vh || rect.bottom <= 0) continue;
      if (rect.left >= vw || rect.right <= 0) continue;
      const area = rect.width * rect.height;
      if (area < 10000) continue;
      if (area > bestArea) { bestArea = area; best = el; }
    }
    if (!best) {
      for (let i = 0; i < candidates.length; i++) {
        const el = candidates[i];
        const w = el.naturalWidth || el.videoWidth || el.width || 0;
        if (w > 200) { best = el; break; }
      }
    }
    return best;
  }

  function fixLcpElementLoading(lcpEl) {
    if (!lcpEl) return;
    const isVideo = lcpEl.tagName === "VIDEO";
    if (isVideo) {
      lcpEl.setAttribute("preload", "auto");
      lcpEl.setAttribute("fetchpriority", "high");
      lcpEl.removeAttribute("data-lazy");
      lcpEl.querySelectorAll("source[data-src]").forEach(function (s) {
        s.src = s.getAttribute("data-src");
        s.removeAttribute("data-src");
      });
      if (!lcpEl.src && lcpEl.dataset.src) {
        lcpEl.src = lcpEl.dataset.src;
        lcpEl.removeAttribute("data-src");
      }
      try { lcpEl.load(); } catch (e) {}
    } else {
      lcpEl.loading = "eager";
      lcpEl.setAttribute("fetchpriority", "high");
      lcpEl.decoding = "sync";
      if (!lcpEl.src && lcpEl.dataset.src) {
        lcpEl.src = lcpEl.dataset.src;
        lcpEl.removeAttribute("data-src");
      }
    }
    lcpEl.classList.remove("lazyload", "lazy", "lazyloaded");
  }

  function removeLcpAnimationsFromElement(lcpImg) {
    if (!lcpImg) return;
    const targets = [lcpImg];
    let parent = lcpImg.parentElement;
    for (let i = 0; i < 3 && parent; i++) {
      targets.push(parent);
      parent = parent.parentElement;
    }
    for (let i = 0; i < targets.length; i++) {
      const el = targets[i];
      el.style.opacity = "1";
      el.style.transform = "none";
      el.style.transition = "none";
      el.style.animation = "none";
      el.removeAttribute("data-reveal");
      el.removeAttribute("data-aos");
      el.removeAttribute("data-motion");
      el.classList.remove("reveal", "fade-in", "slide-up", "motion-reduce");
    }
  }

  function optimizeLcpImage(settings) {
    if (!settings.preloadHeroImage) return;

    const candidates = document.querySelectorAll("img, video");
    const lcpEl = findLcpCandidate(candidates);
    if (!lcpEl) return;

    _lcpElement = lcpEl;

    fixLcpElementLoading(lcpEl);

    if (settings.removeLcpAnimations) {
      removeLcpAnimationsFromElement(lcpEl);
    }

    const isVideo = lcpEl.tagName === "VIDEO";
    if (isVideo) {
      let src = lcpEl.currentSrc || lcpEl.src;
      if (!src) {
        const source = lcpEl.querySelector("source[src], source[data-src]");
        if (source) src = source.src || source.getAttribute("data-src");
      }
      if (src) injectVideoPreloadLink(src);
    } else {
      const src = lcpEl.src || lcpEl.dataset.src || "";
      if (src) injectImagePreloadLink(src);
    }
  }

  // ─── 2. IMAGE OPTIMIZATION ───────────────────────────────────────────────

  function convertToWebP(img) {
    const src = img.src || img.getAttribute("data-src") || "";
    if (src.indexOf("cdn.shopify.com") === -1) return;
    if (src.indexOf("format=webp") !== -1 || src.indexOf(".webp") !== -1) return;
    try {
      const url = new URL(src, location.href);
      url.searchParams.set("format", "webp");
      if (img.src) img.src = url.toString();
    } catch (e) {}
  }

  function injectResponsiveSrcset(img) {
    const src = img.src || img.getAttribute("data-src") || "";
    if (src.indexOf("cdn.shopify.com") === -1 || img.srcset) return;
    const sizes = [360, 540, 720, 900, 1080, 1440, 1920];
    try {
      const parts = [];
      for (let i = 0; i < sizes.length; i++) {
        const url = new URL(src, location.href);
        url.searchParams.set("width", String(sizes[i]));
        url.searchParams.set("format", "webp");
        parts.push(url.toString() + " " + sizes[i] + "w");
      }
      img.srcset = parts.join(", ");
      img.sizes = img.sizes || "(max-width: 768px) 100vw, 50vw";
    } catch (e) {}
  }

  function processImageBatch(images, start, end, settings) {
    for (let i = start; i < end && i < images.length; i++) {
      const img = images[i];
      img.setAttribute("data-toserof-seen", "1");
      if (img === _lcpElement) continue;

      if (settings.preventLayoutShift) {
        if (!img.getAttribute("width") && !img.getAttribute("height")) {
          if (!img.style.aspectRatio) img.style.aspectRatio = "auto";
        }
      }

      if (settings.lazyLoadImages && !img.loading) {
        if (i >= 6) {
          img.loading = "lazy";
          img.setAttribute("fetchpriority", "low");
        }
        img.decoding = "async";
      }

      if (settings.webpConversion) convertToWebP(img);
      if (settings.responsiveImages) injectResponsiveSrcset(img);
    }
  }

  function optimizeImages(settings) {
    const images = Array.prototype.slice.call(
      document.querySelectorAll("img:not([data-toserof-seen])")
    );

    const BATCH = 40;
    let cursor = 0;
    function nextBatch() {
      if (cursor >= images.length) {
        document.querySelectorAll("iframe:not([data-toserof-seen])").forEach(function (iframe) {
          iframe.setAttribute("data-toserof-seen", "1");
          if (iframe.loading) return;
          iframe.loading = "lazy";
        });
        if (settings.lazyLoadImages && "IntersectionObserver" in window) {
          lazyLoadWithObserver();
        }
        return;
      }
      processImageBatch(images, cursor, cursor + BATCH, settings);
      cursor += BATCH;
      idle(nextBatch);
    }
    nextBatch();
  }

  function lazyLoadWithObserver() {
    const lazyImages = document.querySelectorAll("img[data-src]:not([data-toserof-lazy])");
    if (!lazyImages.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.removeAttribute("data-src");
          observer.unobserve(img);
        }
      });
    }, { rootMargin: "200px 0px" });

    lazyImages.forEach(function (img) {
      img.setAttribute("data-toserof-lazy", "1");
      observer.observe(img);
    });
  }

  function lazyBackgroundImages() {
    if (!("IntersectionObserver" in window)) return;
    const elements = document.querySelectorAll("[data-bg]:not([data-toserof-bg])");
    if (!elements.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const el = entry.target;
          const bg = el.getAttribute("data-bg");
          if (bg) {
            el.style.backgroundImage = "url('" + bg + "')";
            el.removeAttribute("data-bg");
          }
          observer.unobserve(el);
        }
      });
    }, { rootMargin: "200px 0px" });

    elements.forEach(function (el) {
      el.setAttribute("data-toserof-bg", "1");
      observer.observe(el);
    });
  }

  // ─── 3. FONT OPTIMIZATION (preserved name) ───────────────────────────────

  function injectDnsPrefetch(href) {
    if (document.querySelector('link[rel="dns-prefetch"][href="' + href + '"]')) return;
    const link = document.createElement("link");
    link.rel = "dns-prefetch";
    link.href = href;
    document.head.appendChild(link);
  }

  function injectFontDisplaySwapAll() {
    document.querySelectorAll('link[rel="stylesheet"][href*="fonts.googleapis.com"]:not([data-toserof-font])').forEach(function (link) {
      link.setAttribute("data-toserof-font", "1");
      const href = link.getAttribute("href") || "";
      if (href.indexOf("display=swap") === -1) {
        link.setAttribute("href", href + (href.indexOf("?") > -1 ? "&" : "?") + "display=swap");
      }
      makeFontLinkNonBlocking(link);
    });

    try {
      for (let i = 0; i < document.styleSheets.length; i++) {
        const sheet = document.styleSheets[i];
        let rules;
        try { rules = sheet.cssRules; } catch (e) { continue; }
        if (!rules) continue;
        for (let j = 0; j < rules.length; j++) {
          const rule = rules[j];
          if (rule instanceof CSSFontFaceRule) {
            if (!rule.style.getPropertyValue("font-display")) {
              try { rule.style.setProperty("font-display", "swap"); } catch (e) {}
            }
          }
        }
      }
    } catch (e) {}
  }

  function optimizeFonts(settings) {
    if (settings.preconnectFonts) {
      injectPreconnect("https://fonts.googleapis.com");
      injectPreconnect("https://fonts.gstatic.com", true);
    }
    if (settings.fontDisplaySwap) {
      injectFontDisplaySwapAll();
    }
    if (settings.dnsPrefetch) {
      injectDnsPrefetch("//cdn.shopify.com");
      injectDnsPrefetch("//fonts.googleapis.com");
      injectDnsPrefetch("//fonts.gstatic.com");
    }
  }

  function preloadCriticalFonts() {
    const preloaded = new Set();
    try {
      for (let i = 0; i < document.styleSheets.length; i++) {
        if (preloaded.size >= 2) break;
        const sheet = document.styleSheets[i];
        let rules;
        try { rules = sheet.cssRules; } catch (e) { continue; }
        if (!rules) continue;
        for (let j = 0; j < rules.length; j++) {
          const rule = rules[j];
          if (!(rule instanceof CSSFontFaceRule)) continue;
          const src = rule.style.getPropertyValue("src");
          const m = src.match(/url\(["']?([^"')]+\.woff2[^"')]*)/);
          if (m && !preloaded.has(m[1])) {
            const link = document.createElement("link");
            link.rel = "preload";
            link.as = "font";
            link.type = "font/woff2";
            link.crossOrigin = "anonymous";
            link.href = m[1];
            document.head.appendChild(link);
            preloaded.add(m[1]);
            if (preloaded.size >= 2) break;
          }
        }
      }
    } catch (e) {}
  }

  function injectCustomPreconnects(domains) {
    if (!Array.isArray(domains)) return;
    domains.slice(0, 2).forEach(function (domain) {
      const href = domain.indexOf("http") === 0 ? domain : "https://" + domain;
      injectPreconnect(href, true);
    });
  }

  // ─── 4. 3RD PARTY DEFER (preserved name) ─────────────────────────────────

  function deferThirdPartyScripts(settings) {
    if (!settings.deferThirdPartyScripts) {
      fireInteraction();
      return;
    }
    if (!settings.delayThirdPartyUntilInteraction) {
      window.addEventListener("load", function () {
        setTimeout(fireInteraction, 200);
      }, { once: true });
    }

    document.querySelectorAll('script[src]:not([data-toserof-processed])').forEach(function (script) {
      const src = script.getAttribute("src") || "";
      script.setAttribute("data-toserof-processed", "1");
      if (!shouldDelayScript(src)) return;

      const parent = script.parentNode;
      const async_ = script.async;
      const defer_ = script.defer;
      const type_ = script.getAttribute("type") || "";
      try { script.remove(); } catch (e) {}

      onInteraction(function () {
        const s = document.createElement("script");
        try { scriptSrcDesc.set.call(s, src); } catch (e) { s.setAttribute("src", src); }
        s.async = async_ !== false;
        if (defer_) s.defer = true;
        if (type_) s.type = type_;
        (parent || document.body).appendChild(s);
      });
    });
  }

  function deferDynamicScripts() {
    if (!("MutationObserver" in window)) return;
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.tagName !== "SCRIPT") return;
          const src = node.src || node.getAttribute("src") || "";
          if (!src) return;
          if (isCriticalJs(src)) return;
          if (shouldDelayScript(src) && !_interactionFired) {
            try { node.remove(); } catch (e) {}
            onInteraction(function () {
              const s = document.createElement("script");
              try { scriptSrcDesc.set.call(s, src); } catch (e) { s.setAttribute("src", src); }
              s.async = true;
              document.body.appendChild(s);
            });
          } else if (!node.defer && !node.async) {
            node.defer = true;
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  // ─── CLS FIX (image dimensions) ──────────────────────────────────────────

  function inferImageRatio(img) {
    const src = img.src || img.getAttribute("data-src") || "";
    if (!src) return false;
    let m = src.match(/_(\d+)x(\d+)\./);
    if (m) {
      img.style.aspectRatio = m[1] + " / " + m[2];
      return true;
    }
    try {
      const url = new URL(src, location.href);
      const w = url.searchParams.get("width");
      const h = url.searchParams.get("height");
      if (w && h) {
        img.style.aspectRatio = w + " / " + h;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function fixImageDimensions() {
    const images = Array.prototype.slice.call(
      document.querySelectorAll("img:not([data-toserof-cls])")
    );
    const BATCH = 60;
    let cursor = 0;
    function processOne(img) {
      img.setAttribute("data-toserof-cls", "1");
      if (img.getAttribute("width") && img.getAttribute("height")) return;
      if (img.style.aspectRatio && img.style.aspectRatio !== "auto") return;
      if (inferImageRatio(img)) return;
      const setRatio = function () {
        const w = img.naturalWidth, h = img.naturalHeight;
        if (w > 0 && h > 0 && (!img.style.aspectRatio || img.style.aspectRatio === "auto")) {
          img.style.aspectRatio = w + " / " + h;
        }
      };
      if (img.complete && img.naturalWidth > 0) {
        setRatio();
      } else {
        img.addEventListener("load", setRatio, { once: true });
      }
    }
    function nextBatch() {
      if (cursor >= images.length) return;
      const end = Math.min(cursor + BATCH, images.length);
      for (let i = cursor; i < end; i++) processOne(images[i]);
      cursor = end;
      idle(nextBatch);
    }
    nextBatch();
  }

  // ─── PRECONNECT CLEANUP ──────────────────────────────────────────────────

  function cleanupPreconnects() {
    document.querySelectorAll('link[rel="preconnect"]').forEach(function (link) {
      const href = link.getAttribute("href") || "";
      let keep = false;
      for (let i = 0; i < PRECONNECT_KEEP.length; i++) {
        if (href.indexOf(PRECONNECT_KEEP[i]) !== -1) { keep = true; break; }
      }
      if (keep) return;
      link.setAttribute("rel", "dns-prefetch");
      link.removeAttribute("crossorigin");
    });
  }

  // ─── 5. CSS DEFER ────────────────────────────────────────────────────────

  function deferNonCriticalCss() {
    document.querySelectorAll('link[rel="stylesheet"]:not([data-toserof-css])').forEach(function (link) {
      link.setAttribute("data-toserof-css", "1");
      if (link.__toserofDeferred) return;
      const href = link.getAttribute("href") || "";
      if (href.indexOf("fonts.googleapis.com") !== -1) {
        makeFontLinkNonBlocking(link);
        _firstCssSeen = true;
        return;
      }
      if (isCriticalCss(href)) { _firstCssSeen = true; return; }
      if (link.hasAttribute("data-shopify")) return;
      if (!_firstCssSeen) { _firstCssSeen = true; return; }
      deferStylesheetLink(link);
    });
  }

  // ─── 6. YOUTUBE FACADE ───────────────────────────────────────────────────

  function setupYoutubeFacade(settings) {
    if (!settings.youtubeFacade) return;
    document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]').forEach(function (iframe) {
      const videoId = extractYoutubeId(iframe.src);
      if (!videoId) return;
      const facade = createYoutubeFacade(videoId, iframe);
      if (iframe.parentNode) iframe.parentNode.replaceChild(facade, iframe);
    });
  }

  function extractYoutubeId(src) {
    const match = src.match(/(?:youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  }

  function createYoutubeFacade(videoId, originalIframe) {
    const wrapper = document.createElement("div");
    wrapper.style.cssText = "position:relative;width:100%;padding-bottom:56.25%;background:#000;cursor:pointer;overflow:hidden;";
    wrapper.setAttribute("data-toserof-yt", videoId);

    const thumb = document.createElement("img");
    thumb.src = "https://i.ytimg.com/vi/" + videoId + "/hqdefault.jpg";
    thumb.alt = "Video";
    thumb.loading = "lazy";
    thumb.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;";

    const playBtn = document.createElement("div");
    playBtn.innerHTML = '<svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.5 7.7c-.8-2.9-2.8-5-5.7-5.8C55.8 0 34 0 34 0S12.2 0 7.2 1.9C4.3 2.7 2.3 4.8 1.5 7.7 0 12.8 0 24 0 24s0 11.2 1.5 16.3c.8 2.9 2.8 5 5.7 5.8C12.2 48 34 48 34 48s21.8 0 26.8-1.9c2.9-.8 4.9-2.9 5.7-5.8C68 35.2 68 24 68 24s0-11.2-1.5-16.3z" fill="red"/><path d="M45 24L27 14v20" fill="white"/></svg>';
    playBtn.style.cssText = "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);";

    wrapper.appendChild(thumb);
    wrapper.appendChild(playBtn);

    wrapper.addEventListener("click", function () {
      const iframe = document.createElement("iframe");
      iframe.src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      iframe.width = originalIframe.width || "100%";
      iframe.height = originalIframe.height || "100%";
      iframe.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:none;";
      iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
      iframe.allowFullscreen = true;
      wrapper.innerHTML = "";
      wrapper.appendChild(iframe);
    });

    return wrapper;
  }

  // ─── 7. VIDEO LAZY LOAD ──────────────────────────────────────────────────

  function lazyLoadVideos(settings) {
    if (!settings.videoLazyLoad || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const video = entry.target;
          video.querySelectorAll("source[data-src]").forEach(function (source) {
            source.src = source.dataset.src;
          });
          try { video.load(); } catch (e) {}
          observer.unobserve(video);
        }
      });
    }, { rootMargin: "200px" });

    document.querySelectorAll("video[data-lazy], video[data-src]").forEach(function (video) {
      if (video === _lcpElement) return;
      observer.observe(video);
    });

    const vh = window.innerHeight;
    document.querySelectorAll("video:not([data-toserof-video])").forEach(function (video) {
      video.setAttribute("data-toserof-video", "1");
      if (video === _lcpElement) return;
      const rect = video.getBoundingClientRect();
      if (rect.top > vh) {
        try { video.preload = "none"; } catch (e) {}
      }
    });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────

  async function init() {
    _settings = await getSettings();
    if (!_settings.enabled) {
      fireInteraction();
      if (_earlyObserver) _earlyObserver.disconnect();
      return;
    }

    if (_settings.aggressiveAnimationKill) {
      injectUniversalTransitionKill();
    }

    const run = function () {
      const tasks = [
        function () { optimizeFonts(_settings); },
        function () { injectCustomPreconnects(_settings.preconnectExternalDomains); },
        function () { if (_settings.cleanupPreconnects) cleanupPreconnects(); },
        function () { optimizeLcpImage(_settings); },
        function () { optimizeImages(_settings); },
        function () { if (_settings.fixImageDimensions) fixImageDimensions(); },
        function () { lazyBackgroundImages(); },
        function () { if (_settings.deferNonCriticalCss) deferNonCriticalCss(); },
        function () { if (_settings.deferNonCriticalJs) deferDynamicScripts(); },
        function () { deferThirdPartyScripts(_settings); },
        function () { setupYoutubeFacade(_settings); },
        function () { lazyLoadVideos(_settings); },
        function () { if (_settings.preloadCriticalFonts) preloadCriticalFonts(); },
        function () { if (_earlyObserver) setTimeout(function () { _earlyObserver.disconnect(); }, 2000); }
      ];
      runChunked(tasks);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run);
    } else {
      run();
    }
  }

  init();
})();
